import { ICellInfo } from 'shared/components/table/GridTable/GridTableModel';

export function showIf(condition: boolean, ...cells: Array<ICellInfo<any>>): Array<ICellInfo<any>> {
    if (condition) {
        return [...cells];
    }
    return [];
}
